import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBarComponent } from './search-bar.component';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule, IconModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { HighlightSearchPipe } from 'src/app/pipes/highlightSearch.pipe';
import { KbVizseekComponent } from '../kb-vizseek/kb-vizseek.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { KbVizseekNoPopupComponent } from '../kb-vizseek/kb-vizseek-no-popup/kb-vizseek-no-popup.component';
import { KbVizseekNoresultsPopupComponent } from '../kb-vizseek/kb-vizseek-noresults-popup/kb-vizseek-noresults-popup.component';
import { KbVizseekYesPopupComponent } from '../kb-vizseek/kb-vizseek-yes-popup/kb-vizseek-yes-popup.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SearchBarComponent,
    KbVizseekComponent,
    KbVizseekNoPopupComponent,
    KbVizseekYesPopupComponent,
    KbVizseekNoresultsPopupComponent,
  ],
  imports: [
    CommonModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    KbPipesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SearchBoxComponent: {
          component: SearchBarComponent
        },
      }
    } as CmsConfig)
  ]
})
export class SearchBarModule { }
